export const theme = `

// @nebular theming framework
@import '~@nebular/theme/styles/theming';
// @nebular out of the box themes
@import '~@nebular/theme/styles/themes';

// which themes you what to enable (empty to enable all)
$nb-enabled-themes: (default, cosmic);

$nb-themes: nb-register-theme((
 // app wise variables for each theme
  sidebar-header-gap: 0,
  sidebar-header-height: initial,
  layout-content-width: 1400px,
  sidebar-bg: #f08c34,
  menu-bg: #f08c34,
  menu-border-type: none,
  menu-item-separator:  transparent,
  menu-active-bg:  #b56809,
  menu-icon-bg: white,
  menu-icon-fg: white,
  menu-icon-active-color:white,
  menu-active-fg: white, 
  menu-group-fg: white,
  menu-fg: white,
  menu-submenu-fg: #fff4e6,
  menu-submenu-bg: #b56809,
  menu-submenu-hover-fg:white,
  menu-submenu-hover-bg: #b56809,
  menu-submenu-active-border-color: #b56809,
  menu-submenu-active-fg:  white,
  menu-submenu-active-bg:  #b56809,
  color-fg-highlight: #b56809,
  menu-submenu-item-border-radius: 0,
  popover-border: #b56809,
  context-menu-fg:#b56809,
  context-menu-active-fg:#b56809,
  color-success: transparent,
  font-main: Roboto,
  font-secondary: Exo,
  scrollbar-width: 10px,
  card-padding: 0.75rem,
), default, default);

::ng-deep .layout nb-layout-header nav {
  height: auto !important;
  padding: 0px !important;
  background-color: whitesmoke !important;
}

:host ::ng-deep .main-content {
  padding: 0 !important;
}
.quickFilter {
  border: 1px solid #d4d4d4;
  border-radius: 3px;
  padding: 12px;
  width: 100%;
}
.btn-creare {
  cursor: pointer !important;
  background-color: #CC4040;
  color: white!important;
  transition: background-color ease 150ms!important;
}
.btn-creare:hover {
  background-color: #CC4040d5;

}

.btn-creare:disabled {
  color:black!important;
}

.nb-theme-default ul {
  padding-left: 0px !important;
}

.nb-theme-default nb-menu i {
  color: white!important;
}

.nb-theme-default .ui-paginator a:hover {
  color: #CC4040!important;
}

.nb-theme-default .ui-paginator-icon:active {
  color: #CC4040!important;
}

.nb-theme-default .modal-content {
  width: 100%!important;
}

.nb-theme-default .form-control {
  color: #4B4B4D!important;
}
.nb-theme-default nb-card-header {
  font-family: 'Roboto', sans-serif!important;
  color: #4B4B4D!important;
}

.close {
  font-size: 2.5em;
  padding: 9px 15px 0px 15px !important;
}
.ag-row-focus {
  background-color: #bce3ff !important;
  color: #1b3042 !important;
}
.nb-theme-default nb-card-body {
  overflow: visible !important;
}

.nb-theme-default nb-card {
  color: #4B4B4D!important;
}

.main-container {
  box-shadow: none!important;
}


.ui-state-highlight {
  background-color: #e8e8e8 !important;
  color: #525252 !important;
  margin: 2px !important;
  padding-bottom: 6px !important;
}
.btn-danger {
  background-color: #cc0022 !important;
}

// Focus DataTable PrimeNG
.ui-table .ui-table-thead > tr > th, .ui-table .ui-table-tfoot > tr > td {
  border: 0px !important;
  border-bottom: 2px solid #e0e0e0 !important;
  color: #3e5f80 !important;
  background-color: #f6f7f9 !important;
  font-size: 1em !important;
  padding: 0.7em !important;
}
.ui-table .ui-table-tbody > tr > td {
  border: 0px !important;
  border-bottom: 1px solid #eaebef !important;
  font-size: 14px;
}

// Focus ListBox PrimeNG
.ui-listbox {
  width: 100% !important;
  height: 100% !important;
}
.ui-table .ui-sortable-column.ui-state-highlight .ui-sortable-column-icon {
  color: #4B4B4D !important;
}
.ui-table .ui-sortable-column .ui-sortable-column-icon {
  color: #4B4B4Dd5 !important;
}

:host ::ng-deep .ui-table .ui-table-thead>tr>th {
  color: #4B4B4D !important;
  font-size: 14px!important;
}

:host ::ng-deep .nb-menu {
    font-weight: bold;
    color: #b56809 !important;
}

.ui-overlaypanel-content {
  padding: 5px !important;
}

.ui-paginator .ui-paginator-page.ui-state-active {
  background: #4B4B4D!important;
  color: #ffffff !important;
  border-color: #4B4B4D!important;
  &:hover{
    color:#ffffff!important;
  }
}

// Focus MultiSelect Menu Filter
.ui-clickable:hover, .pi-check:hover {
  background-color: transparent!important;
}

div.ui-treenode-content:not(.ui-treenode-selectable) div.ui-chkbox{
  display: none !important;
  visibility: hidden !important;
}

/**
* Modal de Tratativas
**/
.carroucelVehicle {
  background-color: #333 !important;
  border: 1px solid #333 !important;
  border-radius: 0px !important;
}

/**
* InputMultiselect
*/
.inputMultiSelect {
  border: 1px solid #d6d6d6;
  border-radius: 3px;
  padding: 0.75em;
  cursor: pointer;
}
.inputMultiSelect:hover {
  border: 1px solid #a7a6a6;
  background-color: #fbfafa;
}
.inputMultiSelect::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  right: 30px;
  top: 40%;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 6px solid #4B4B4D;
}

/*
* MARKER CLUSTER
*/
.marker-cluster-small {
  background-color: rgba(181, 226, 140, 0.6);
}
.marker-cluster-small div {
  background-color: rgba(110, 204, 57, 0.6);
}
.marker-cluster-medium {
  background-color: rgba(241, 211, 87, 0.6);
}
.marker-cluster-medium div {
  background-color: rgba(240, 194, 12, 0.6);
}
.marker-cluster-large {
  background-color: rgba(253, 156, 115, 0.6);
}
.marker-cluster-large div {
  background-color: rgba(241, 128, 23, 0.6);
}

/* IE 6-8 fallback colors */
.leaflet-oldie .marker-cluster-small {
  background-color: rgb(181, 226, 140);
}
.leaflet-oldie .marker-cluster-small div {
  background-color: rgb(110, 204, 57);
}
.leaflet-oldie .marker-cluster-medium {
  background-color: rgb(241, 211, 87);
}
.leaflet-oldie .marker-cluster-medium div {
  background-color: rgb(240, 194, 12);
}
.leaflet-oldie .marker-cluster-large {
  background-color: rgb(253, 156, 115);
}
.leaflet-oldie .marker-cluster-large div {
  background-color: rgb(241, 128, 23);
}
.marker-cluster {
  background-clip: padding-box;
  border-radius: 20px;
  color: #163304;
}
.marker-cluster div {
  width: 30px;
  height: 30px;
  margin-left: 5px;
  margin-top: 5px;
  text-align: center;
  border-radius: 15px;
  font: 12px "Helvetica Neue", Arial, Helvetica, sans-serif;
}
.marker-cluster span {
  line-height: 30px;
}
.leaflet-cluster-anim .leaflet-marker-icon, .leaflet-cluster-anim .leaflet-marker-shadow {
  -webkit-transition: -webkit-transform 0.3s ease-out, opacity 0.3s ease-in;
  -moz-transition: -moz-transform 0.3s ease-out, opacity 0.3s ease-in;
  -o-transition: -o-transform 0.3s ease-out, opacity 0.3s ease-in;
  transition: transform 0.3s ease-out, opacity 0.3s ease-in;
}
.leaflet-cluster-spider-leg {
  /* stroke-dashoffset (duration and function) should match with leaflet-marker-icon transform in order to track it exactly */
  -webkit-transition: -webkit-stroke-dashoffset 0.3s ease-out, -webkit-stroke-opacity 0.3s ease-in;
  -moz-transition: -moz-stroke-dashoffset 0.3s ease-out, -moz-stroke-opacity 0.3s ease-in;
  -o-transition: -o-stroke-dashoffset 0.3s ease-out, -o-stroke-opacity 0.3s ease-in;
  transition: stroke-dashoffset 0.3s ease-out, stroke-opacity 0.3s ease-in;
}
:host ::ng-deep .layout-container {
  min-height: 0vh !important;
}

:host ::ng-deep .font-2-em {
  font-size: 2em !important;
}
`;

export const VECCH_THEME = {
  name: 'vecch',
  base: 'default',
}